<div #overlay class="overlay">
  <div class="content center-content">
    <div class="column-flex">
      <mat-icon svgIcon="cloud" data-cy="vessel-folder-publish-version-confirmation-modal-icon" />
      <div class="approve-title" data-cy="vessel-folder-publish-version-confirmation-modal-header">
        {{ 'publish.vessel.dialog.title' | translate: { version: data.projectVersion } }}
      </div>
      <div class="approve-message" data-cy="vessel-folder-publish-version-confirmation-modal-body">
        {{ 'publish.vessel.dialog.message' | translate }}
      </div>
      <div class="buttons-container">
        <div
          class="cancel button"
          data-cy="vessel-folder-publish-version-confirmation-modal-cancel-btn"
          (click)="cancel()">
          {{ 'publish.vessel.dialog.button.cancel' | translate }}
        </div>
        <div
          class="create button"
          data-cy="vessel-folder-publish-version-confirmation-modal-confirm-btn"
          (click)="acceptUnlock()">
          {{ 'publish.vessel.dialog.button.confirm' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
